import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { CandidateEditNavigationState, shouldOpenCandidateConsentForm } from './candidateAiRefreshNavigation';

// Reads the CV suggestions page's "Go to Consents" request once, then drops it from the history entry
// so a reload or Back does not reopen the consent form.
export const useConsumeOpenConsentsNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [requested] = useState(() => shouldOpenCandidateConsentForm(location.state));

  useEffect(() => {
    if (!shouldOpenCandidateConsentForm(location.state)) return;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { openConsentForm, ...rest } = location.state as CandidateEditNavigationState;
    navigate(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      { replace: true, state: Object.keys(rest).length ? rest : null }
    );
  }, [location, navigate]);

  return requested;
};
